export default "__VITE_ASSET__3c55239e__"